<div class="row">
  <!-- Stripe Snackbar -->
  <roma-shared-stripe-snackbar></roma-shared-stripe-snackbar>

  <!-- Trial Disclaimer -->
  <roma-pro-disclaimer-banner
    *ngIf="isLowerThan1450px"
    (emitRefresh)="refresh()"
    [rootModule]="'timetracking2'"
  ></roma-pro-disclaimer-banner>

  <roma-mf-time-tracking
    (onClickDownload)="downloadReport()"
    (onUpdateStopwatch)="refreshList()"
  ></roma-mf-time-tracking>
</div>

<div class="row">
  <div class="col--12">
    <div class="total-info-header">
      <div class="clockhours-filters">
        <div class="filter-wrapper">
          <button
            class="btn sm"
            [ngClass]="{ active: view === clockHourViewRef.Week }"
            (click)="changeClockHourView(clockHourViewRef.Week)"
          >
            {{ 'clockHour.weekly' | translate }}
          </button>
          <button
            class="btn sm"
            [ngClass]="{ active: view === clockHourViewRef.Month }"
            (click)="changeClockHourView(clockHourViewRef.Month)"
          >
            {{ 'clockHour.monthly' | translate }}
          </button>
        </div>
      </div>
      <div *ngIf="isLoadingMetrics" class="col-12">
        <roma-loading></roma-loading>
      </div>
      <div *ngIf="!isLoadingMetrics" class="wrapper-total-hours">
        <div class="row">
          <div class="col-md-3 col-6 pr-6">
            <roma-time-display
              [clockHours]="userMetrics.workedHours"
              [clockHoursLabel]="'clockHour.totalHours' | translate"
              [icon]="'clock-fill'"
              [clickable]="false"
              [totalHours]="userMetrics.contractHours"
            ></roma-time-display>
          </div>
          <div class="col-md-3 col-6 pl-6">
            <roma-time-display
              [clockHours]="userMetrics.remainingHours"
              [clockHoursLabel]="
                'person.create.form.hoursToClockIn' | translate
              "
              [icon]="'to-clock-in'"
              [clickable]="userMetrics.contractHours === null"
              (updateMetrics)="updateMetrics()"
            ></roma-time-display>
          </div>
          <div class="col-md-3 col-12">
            <roma-time-display
              [clockHours]="userMetrics.extraHours"
              [clockHoursLabel]="'person.create.form.overtime' | translate"
              [icon]="'clock-overtime'"
              [clickable]="userMetrics.contractHours === null"
              [fullWidthMobile]="true"
              (updateMetrics)="updateMetrics()"
            ></roma-time-display>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="wrapper-overlay" style="display: contents">
  <div class="clockhours-filters">
    <div class="wrapper-pagination">
      <button
        class="btn arrow-btn prev"
        (click)="
          view === clockHourViewRef.Week
            ? changeWeek(firstWeekDay, 'prev')
            : changeMonth(selectedMonth - 1, 'prev')
        "
      >
        <img src="assets/icons/gl_arrow_left.svg" />
      </button>
      <div *ngIf="view === clockHourViewRef.Week" class="filter-info">
        {{ firstWeekDay }}
        {{
          lastWeekDay < firstWeekDay
            ? stringRemainingMonth
            : (stringMonth | titlecase)
        }}
        - {{ lastWeekDay }} {{ stringMonth | titlecase }}
      </div>
      <div *ngIf="view === clockHourViewRef.Month" class="filter-info">
        {{ stringMonth | titlecase }} {{ currentYear }}
      </div>
      <button
        class="btn arrow-btn next"
        (click)="
          view === clockHourViewRef.Week
            ? changeWeek(lastWeekDay + 1, 'next')
            : changeMonth(selectedMonth + 1, 'next')
        "
      >
        <img src="assets/icons/gl_arrow_left.svg" />
      </button>
    </div>
    <roma-shared-download-btn
      *ngIf="clockHours?.length && !(resize$ | async)?.payload?.mobile"
      [featureExcel]="featureRef.ClockHour.DownloadExcel"
      [showDownloadExcel]="true"
      [showDownloadPdf]="false"
      (download)="downloadReport($event)"
      [ngClass]="{ 'is-hidden': isLoading }"
    ></roma-shared-download-btn>
  </div>

  <ng-container *ngIf="(resize$ | async)?.payload?.mobile">
    <roma-list-mobile-clock-hour
      *ngIf="!isLoading && clockHours"
      [data]="clockHours"
      (actions)="makeMobileActions($event)"
      [canClockIn]="!clockInWithStopwatchMandatory"
      typeView="clockHours"
    ></roma-list-mobile-clock-hour>
  </ng-container>

  <div
    id="containerTable"
    class="containerTable"
    [ngStyle]="{ 'margin-top': tableMarginTop }"
    (scroll)="checkScroll($event)"
  >
    <div class="my-4">
      <div *ngIf="isLoading" class="col-12">
        <roma-loading></roma-loading>
      </div>

      <div
        *ngIf="!(resize$ | async)?.payload?.mobile"
        class="col-12"
        [ngClass]="{ 'is-hidden': isLoading || !clockHours?.length }"
      >
        <roma-table
          class="table"
          type="clockHours"
          idModule="CLOCK_HOUR_MODULE"
          [appendSettings]="'NO'"
          [tagNotAvailable]="'activity.notAvailable' | translate"
          [data]="clockHours"
          [displayedColumns]="columns"
          [showActions]="true"
          (wantEdit)="launchModalClockHourEdit($event)"
          (wantDelete)="deleteClockHour($event)"
          [canClockIn]="!clockInWithStopwatchMandatory"
        >
        </roma-table>
      </div>
    </div>
  </div>
  <div *ngIf="openMobileActions" class="mobile-viewtype-wrapper mobile-actions">
    <div class="viewtype-list">
      <h4>{{ 'general.actions' | translate }}</h4>
      <div class="link-list">
        <div
          *ngIf="getLang() === 'es'"
          class="list-item"
          (click)="openVideo('clock-hours-mine'); openMobileTeamActions = false"
        >
          <span class="icon-text">
            {{ 'tutorial.tutorial' | translate }}
          </span>
          <mat-icon class="material-icons mr-1 prev-icon">
            play_arrow
          </mat-icon>
        </div>
        <div
          class="list-item"
          (click)="downloadReport(); openMobileActions = false"
        >
          <span class="icon-text">
            {{ 'general.downloadExcel' | translate }}
          </span>
          <mat-icon class="material-icons mr-1 prev-icon">
            download_alt
          </mat-icon>
        </div>
        <div class="text-center close-btn-wrapper">
          <img
            (click)="openMobileActions = false"
            class="close-btn"
            src="/assets/icons/btn_close.svg"
            alt="close"
          />
        </div>
      </div>
    </div>
  </div>
</div>
